export default __webpack_public_path__ + "static/media/userCheckIcon.8fa0dd4b.svg";